import { render, staticRenderFns } from "./Direct.vue?vue&type=template&id=3b698f27&scoped=true&"
import script from "./Direct.vue?vue&type=script&lang=js&"
export * from "./Direct.vue?vue&type=script&lang=js&"
import style0 from "./Direct.vue?vue&type=style&index=0&id=3b698f27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b698f27",
  null
  
)

export default component.exports